import axios from "axios";
import { getToken } from "../../../auth/authService";

const makeApi = (path) => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL + path,
    headers: { "Content-Type": "application/json" },
  });
  instance.interceptors.request.use((config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  return instance;
};

const api = makeApi("/admin/reading");
const categoryApi = makeApi("/admin/reading/category");
const difficultyApi = makeApi("/admin/reading/difficulty");
const searchApi = makeApi("/admin/reading/search");

const handle = (promise) =>
  promise
    .then((res) => ({ status: res.status, data: res.data }))
    .catch((err) => ({
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Request failed",
    }));

// Passages
export const fetchReadingPassages = (params) => handle(api.get("", { params }));
export const fetchReadingById = (id) => handle(api.get(`/${id}`));
export const createReading = (data) => handle(api.post("", data));
export const updateReading = (id, data) => handle(api.put(`/${id}`, data));
export const deleteReading = (id) => handle(api.delete(`/${id}`));

// Categories CRUD
export const fetchCategories = () => handle(categoryApi.get(""));
export const createCategory = (data) => handle(categoryApi.post("", data));
export const updateCategory = (id, data) => handle(categoryApi.put(`/${id}`, data));
export const deleteCategory = (id) => handle(categoryApi.delete(`/${id}`));

// Difficulties CRUD
export const fetchDifficulties = () => handle(difficultyApi.get(""));
export const createDifficulty = (data) => handle(difficultyApi.post("", data));
export const updateDifficulty = (id, data) => handle(difficultyApi.put(`/${id}`, data));
export const deleteDifficulty = (id) => handle(difficultyApi.delete(`/${id}`));

// Search
export const searchVocabulary = (q) => handle(searchApi.get("/vocabulary", { params: { q } }));
export const searchPhrases = (q) => handle(searchApi.get("/phrases", { params: { q } }));
export const searchPassages = (q) => handle(searchApi.get("/passages", { params: { q } }));
